const JOBS_URL = "https://api.greenhouse.io/v1/boards/peerstreet/jobs?content=true";

class Greenhouse {
  static listJobs(cb) {
    return $.ajax({ method: "GET", url: JOBS_URL, success: cb });
  }
}

PS.Services.Greenhouse = Greenhouse;
